// FILECONTENT_START src/common/components/Form/FormSectionTitle.tsx
import { Grid, Typography, TypographyProps } from "@mui/material";
import { useThemeProps } from "./../../modules/theme";
import Spacer from "./../Spacer";
import Toolbar, { ToolbarProps } from "./../Toolbar";

export interface FormSectionTitleProps extends ToolbarProps {
  title: string;
  titleProps?: TypographyProps;
  allignButtonsLeft?: boolean;
}

export default function FormSectionTitle(_props: FormSectionTitleProps) {
  const { title, titleProps, children, ...props } =
    useThemeProps<FormSectionTitleProps>(_props, "MuiFormSectionTitle");

  return (
    <Grid sx={{ marginBottom: -1.5 }} item xs={12}>
      <Toolbar className="MuiFormSectiontitle" {...props}>
        <Typography variant="h5" {...titleProps}>
          {title}
        </Typography>
        {!!children && _props.allignButtonsLeft !== true && <Spacer right />}
        {children}
      </Toolbar>
    </Grid>
  );
}

// FILECONTENT_END src/common/components/Form/FormSectionTitle.tsx
